import { Component, OnInit } from '@angular/core';
import { DataPointDataType, DynamicComponentBase, IDynamicComponentConfig } from '../../../dynamic-component';

@Component({
  selector: 'app-d-con-timestamp-config',
  templateUrl: './d-con-timestamp-config.component.html',
  styles: []
})
export class DConTimestampConfigComponent extends DynamicComponentBase implements OnInit {
  static KEY = 'd-con-timestamp-config';
  dataType = DataPointDataType;
  constructor() {
    super();
  }
  ngOnInit() {
    /** 数据类型设置 */
    this.config.dataType = this.dataType.Timestamp;
  }
  configChange(config: IDynamicComponentConfig) {}
}
